import React from 'react';
import Lottie from 'lottie-react';
import { makeStyles } from '@material-ui/core/styles';
import loadingAnimation from '../assets/loading-gif.json';

interface Props {
  isFormGroup?: Boolean;
}

const defaultProps: Props = {
  isFormGroup: false
};

const LoadingComponent: React.FC<Props> = ({ isFormGroup }) => {
  const useStyles = makeStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  });

  const classes = useStyles();

  return (
    <div
      className={classes.container}
      style={{
        backgroundColor: '#F5F5F5',
        padding: 15,
        minHeight: isFormGroup ? window.innerHeight : window.innerHeight - 150
      }}
    >
      <Lottie
        loop={true}
        autoplay={true}
        animationData={loadingAnimation}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice'
        }}
        width={200}
      />
    </div>
  );
};
LoadingComponent.defaultProps = defaultProps;
export default LoadingComponent;
